<template>
  <div >

    <div class="row">
        <div class="col-lg-12" style="padding:1.75em 2.2em;">
            <div class="row">
                <router-view />
        </div>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  name: "App",
  components: {
  },
  mounted(){
     this.$store.commit('setAabAnalyticsGlobal');
  }
};
</script>
<style lang="css">
@import './style/new.css' ;

</style>
